@if (icon()) {
	<svg-icon
		class="{{ generalStyles() }}"
		[attr.data-cy]="'ui-icon-' + icon()"
		[size]="size()"
		[key]="icon() || ''"
		[color]="color()"
		(click)="clickedOnIcon($event)"
	></svg-icon>
}
